import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { money } from "@/lib/api";
import PortalLayout from "@/components/portal/PortalLayout";
import StatusBadge from "@/components/StatusBadge";

export default function PortalOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/my/orders").then((r) => setOrders(r.data)).catch(() => {}); }, []);
  return (
    <PortalLayout title="My Orders">
      {orders.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border p-12 text-center text-muted-foreground">No orders yet.</div>
      ) : (
        <div className="grid gap-3">
          {orders.map((o) => {
            const paid = (o.schedule || []).filter((x) => x.paid).length;
            return (
              <Link key={o.id} to={`/portal/orders/${o.id}`} className="flex flex-col gap-3 rounded-xl border border-border bg-card p-4 hover:border-primary/50 sm:flex-row sm:items-center" data-testid={`order-row-${o.id}`}>
                <img src={o.product_image} alt={o.product_name} className="h-16 w-16 rounded-lg object-cover" />
                <div className="flex-1"><p className="font-semibold">{o.product_name}</p><p className="text-xs text-muted-foreground">{o.order_no} · {o.plan_name}</p><p className="mt-1 text-sm">{paid}/{o.schedule?.length} installments · {money(o.monthly_installment)}/mo</p></div>
                <div className="flex items-center gap-3"><StatusBadge status={o.status} /><span className="font-display font-bold text-primary">{money(o.total_payable)}</span></div>
              </Link>
            );
          })}
        </div>
      )}
    </PortalLayout>
  );
}
